// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/preflight-planning.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/preflight-planning/preflight-planning.js';
import g1 from '../lessons/navigation/preflight-planning/weather-first-planning.js';

mount([g0, g1]);
